import { Group } from '@mantine/core';

interface StickyContainerProps {
  children: any;
  noPl?: boolean;
}

export const StickyContainer: React.FC<StickyContainerProps> = ({ children, noPl }) => {
  return (
    <Group
      justify="start"
      pos="sticky"
      bottom={0}
      bg={'white'}
      mih="80px"
      pl={noPl ? '' : 'xl'}
      styles={{
        root: {
          zIndex: 2,
        },
      }}
    >
      {children}
    </Group>
  );
};
